import { Link } from "react-router-dom"

const RequestList = () => {
    return (
        <>
            <div className="request-list">
                <div className="d-flex align-items-center flex-wrap justify-content-between">
                    <div className="d-flex align-items-center flex-wrap">
                        <span>
                            <img src="https://www.pngitem.com/pimgs/m/581-5813504_avatar-dummy-png-transparent-png.png" alt="" />
                        </span>
                        <h6 className="m-0 ms-3">Vivek Mishra<br />
                            <small>Requested on: <span className="text-muted">12 May 2033</span></small>
                        </h6>
                    </div>
                    <span>
                        <span className="text-muted">Price Quoted</span>
                        <br />
                        <span><b><i className="fa fa-rupee"></i>5000</b></span>
                    </span>
                </div>
                <hr />

                <div className="d-flex align-items-center justify-content-between">
                    <div className="d-flex flex-fill">
                        Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s,
                    </div>
                    <Link className="w-25 text-end"><u>View Chat</u></Link>
                </div>
            </div>
        </>
    )
}

export default RequestList